export var HttpStatusCodesEnum;
(function (HttpStatusCodesEnum) {
    HttpStatusCodesEnum[HttpStatusCodesEnum["ACCEPTED"] = 202] = "ACCEPTED";
    HttpStatusCodesEnum[HttpStatusCodesEnum["BAD_REQUEST"] = 400] = "BAD_REQUEST";
    HttpStatusCodesEnum[HttpStatusCodesEnum["CONFLICTS"] = 409] = "CONFLICTS";
    HttpStatusCodesEnum[HttpStatusCodesEnum["CREATED"] = 201] = "CREATED";
    HttpStatusCodesEnum[HttpStatusCodesEnum["FORBIDDEN"] = 403] = "FORBIDDEN";
    HttpStatusCodesEnum[HttpStatusCodesEnum["FOUND"] = 302] = "FOUND";
    HttpStatusCodesEnum[HttpStatusCodesEnum["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
    HttpStatusCodesEnum[HttpStatusCodesEnum["NO_CONTENT"] = 204] = "NO_CONTENT";
    HttpStatusCodesEnum[HttpStatusCodesEnum["NOT_FOUND"] = 404] = "NOT_FOUND";
    HttpStatusCodesEnum[HttpStatusCodesEnum["OK"] = 200] = "OK";
    HttpStatusCodesEnum[HttpStatusCodesEnum["PERMANENT_REDIRECT"] = 301] = "PERMANENT_REDIRECT";
    HttpStatusCodesEnum[HttpStatusCodesEnum["SEE_OTHER"] = 303] = "SEE_OTHER";
    HttpStatusCodesEnum[HttpStatusCodesEnum["NOT_MODIFIED"] = 304] = "NOT_MODIFIED";
    HttpStatusCodesEnum[HttpStatusCodesEnum["TEMPORARY_REDIRECT"] = 304] = "TEMPORARY_REDIRECT";
    HttpStatusCodesEnum[HttpStatusCodesEnum["PRECONDITION_FAILED"] = 412] = "PRECONDITION_FAILED";
    HttpStatusCodesEnum[HttpStatusCodesEnum["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
    HttpStatusCodesEnum[HttpStatusCodesEnum["TIMEOUT"] = 504] = "TIMEOUT";
    HttpStatusCodesEnum[HttpStatusCodesEnum["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
    HttpStatusCodesEnum[HttpStatusCodesEnum["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    HttpStatusCodesEnum[HttpStatusCodesEnum["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
})(HttpStatusCodesEnum || (HttpStatusCodesEnum = {}));
//# sourceMappingURL=http-status-codes.enum.js.map